module.exports = __webpack_public_path__ + "img/tags.a753e804.svg";